module.exports = __webpack_public_path__ + "static/media/mainSlide2.9066c8ea.jpg";